import { clsx, type ClassValue } from 'clsx';

/** Conditional className join. Tailwind-friendly. */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
